import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { LossAndDamageSearchFilters } from '@/views/screens/Claims/types';

export interface ClaimsExportRequestParams
  extends Omit<LossAndDamageSearchFilters, 'startDate' | 'endDate' | 'claimStatus' | 'daysOld'> {
  claimStatus: string;
  claimNo?: string;
  startDate?: string;
  endDate?: string;
  daysOld?: number;
  IsAdvanceSearch: boolean;
}

export type ClaimsExportResponseRow = Record<string, unknown>;

export const getClaimsExportAPI = (params: ClaimsExportRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.LOSS_AND_DAMAGE}/GetClaimDataForPrintResult`,
  });
};

export const fetchClaimsExport = async (params: ClaimsExportRequestParams): Promise<ClaimsExportResponseRow[]> => {
  const response: AxiosResponse<ClaimsExportResponseRow[] | { item1?: ClaimsExportResponseRow[] }> =
    await getClaimsExportAPI(params);
  const responseData = response.data;

  if (Array.isArray(responseData)) {
    return responseData;
  }

  return responseData?.item1 ?? [];
};
